/****************************************************
 * Module Name:  packetRemark.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Typography, Tooltip } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import LossProxy from "../../utility/proxy/manager/manufacturingProxy/lossProxy";
import { LoadingButton } from "@mui/lab";
import DepartmentProxy from "../../utility/proxy/manager/manufacturingProxy/departmentProxy";
import Utility from "../../utility/utility";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import CircularProgress from "@mui/material/CircularProgress";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

export default class PacketRemark extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newRemarkCategory: "",
            newdescription: "",
            newCarat: "",
            newPrice: this.props.sourceData.price,
            showError: false,
            categoryOptions: [],
            showCategoryLoadSpinner: true,
            showErrorMessage: '',
            showPriceErrorMessage: '',
            user: "",
            userOptions: [],

            showUserDetailModal: false,
            userIds: [],
        };
        this.getAllcategory(false);
        this.getAllUser();
    }

    getAllcategory = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showCategoryLoadSpinner: true });
        LossProxy.GetAllLossMini((response) =>
            this.setAllCategoryData(response)
        );
    };

    getAllUser = () => {
        DepartmentProxy.GetSingleDepartmentUsers([Constants.loggedInUser.id], (response) => {
            if (response) {
                this.setAllUserData(response)
            } else {
                this.setState({
                    showError: true
                })
            }
        }
        );
    };

    setAllUserData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.userId,
                label: data.userName,
            };
            optionsArray.push(option);
            return true;
        });
        this.setState({
            userOptions: optionsArray,
            user:
                this.state.user === "" && optionsArray.length > 0
                    ? optionsArray[0]
                    : this.state.user,
            userIds: optionsArray.filter(option => option.value !== "").map(option => option.value),
        });
    };


    setAllCategoryData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.category,
            };
            optionsArray.push(option);

            return true;
        });
        this.setState({
            categoryOptions: optionsArray,
            showCategoryLoadSpinner: false,
        });
    };


    handleSave = () => {
        let data = {
            kapanid: this.props.kapanId,
            packetid: this.props.packetId,
            oldcarat: this.props.sourceData.carats,
            oldprice: this.props.sourceData.price,
            newcarat: this.state.newCarat,
            newprice: this.state.newPrice,
            remark: this.state.newdescription,
            responsibleuserid: this.state.user.value,
            reportedbyuser: Constants.loggedInUser.id,
            losscategoryid: this.state.newRemarkCategory.value,
            reportedbydepartment: this.props.sourceData.department_id
        };


        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add Loss Remark validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />
                {this.state.showUserDetailModal ? (
                    <UserDetailModal
                        show={true}
                        handleClose={() => this.setState({ showUserDetailModal: false })}
                        handleSelect={(selectedOption) => {
                            const selectedCustomers = this.state.userOptions.filter(opt =>
                                selectedOption.includes(opt.value)
                            );
                            this.setState({ user: selectedCustomers[0], showUserDetailModal: false })
                        }}
                        userids={this.state.userIds}
                        selectedIds={this.state.user !== "" ? [this.state.user.value] : []}
                        usertype={"U"}
                        loading={this.state.showUserDetailModal}
                        isMulti={false}
                    />
                ) : null}

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            Add New Loss Remark
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label>Old Carat</Form.Label>
                                        </td>
                                        <td>
                                            <Typography>{this.props.sourceData.carats}</Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Old Price</Form.Label>
                                        </td>
                                        <td>
                                            <Typography>{this.props.sourceData.price}</Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>New Carat<sup style={{ color: "red" }}>*</sup></Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Enter Carat"
                                                placeholder="Enter Carat"
                                                value={this.state.newCarat}
                                                onChange={(e) => {
                                                    this.setState({
                                                        newCarat: e.target.value,
                                                        showErrorMessage: !Utility.CheckisNumberNegative(e.target.value) ? e.target.value <= this.props.sourceData.carats ? '' : 'Entered Carat Should be less than old carat' : 'Entered Carat Should be less than old Carat',
                                                    })
                                                }
                                                }
                                                helperText={this.state.showErrorMessage}
                                                error={this.state.showErrorMessage.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>New Price Per Carat<sup style={{ color: "red" }}>*</sup></Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                type="number"
                                                size="small"
                                                label="Enter Price Per Carat"
                                                placeholder="Enter Price Per Carat"
                                                value={this.state.newPrice}
                                                helperText={this.state.showPriceErrorMessage}
                                                error={this.state.showPriceErrorMessage.length > 0}
                                                onChange={(e) => {
                                                    if (Utility.CheckisNumberNegative(e.target.value)) {
                                                        this.setState({
                                                            newPrice: '',
                                                            showPriceErrorMessage: 'Entered Price Should be a positive number'
                                                        })
                                                    } else {
                                                        this.setState({
                                                            showPriceErrorMessage: '',
                                                            newPrice: e.target.value,
                                                        })
                                                    }
                                                }
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Responsible User<sup style={{ color: "red" }}>*</sup></Form.Label>
                                        </td>
                                        <td>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => option.value}
                                                value={this.state.user}
                                                isSearchable={true}
                                                closeMenuOnSelect={true}
                                                name="User"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.userOptions}
                                                onChange={(selectedOption) =>
                                                    this.setState({
                                                        user: selectedOption,
                                                    })
                                                }
                                            />
                                        </td>
                                        <td>
                                            <Tooltip title="View More Data">
                                                <span style={{ cursor: "pointer", marginLeft: "5px" }}>
                                                    <OpenInNewIcon
                                                        style={{ fontSize: '20px', marginBottom: "3px" }}
                                                        onClick={() => {
                                                            this.setState({ showUserDetailModal: true });
                                                        }}
                                                        color="action"
                                                    />
                                                </span>
                                            </Tooltip>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Loss Category<sup style={{ color: "red" }}>*</sup></Form.Label>
                                        </td>
                                        <td>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => option.value}
                                                value={this.state.newRemarkCategory}
                                                isSearchable={true}
                                                closeMenuOnSelect={true}
                                                name="Loss Category"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.categoryOptions}
                                                onChange={(selectedOption) =>
                                                    this.setState({
                                                        newRemarkCategory: selectedOption,
                                                    })
                                                }
                                            />
                                        </td>
                                        <td>
                                            {this.state.showCategoryLoadSpinner ? (
                                                <CircularProgress
                                                    size="1em"
                                                    sx={{ mt: 1.5, ml: 0.7 }}
                                                />
                                            ) : (
                                                <Tooltip title="Reload">
                                                    <RefreshOutlinedIcon
                                                        color="primary"
                                                        fontSize="medium"
                                                        onClick={() => this.getAllcategory(true)}
                                                        sx={{
                                                            cursor: "pointer",
                                                            mt: 1,
                                                        }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Remark</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                multiline
                                                label="Remark"
                                                placeholder="Enter Remark"
                                                value={this.state.newdescription}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newdescription: e.target.value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={(!this.state.newRemarkCategory || this.state.showErrorMessage.length > 0 || !this.state.user || this.state.user.length === 0 || this.state.user === "" || this.state.newPrice.length <= 0 || this.state.newCarat.length <= 0 || (Number(this.state.newCarat) >= Number(this.props.sourceData.carats))) ? true : false}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box >
        );
    }
}
